import { checkImportExact, clearExistingScheduledImports} from './import';
import { getCookie, getCurrentUser, enableUpdateImports, updateUserLastAction } from './utils';

// Handles exactonline import execution on the server
export async function handleImport(row, updateStatus){
  // await checkImportExact(data[id].entiteit, data[id].year, data[id].budget_scenario, office);
  try {
    handleStatus(updateStatus, true);

    const response = await fetch('/xero/handleImport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json' 
      },
      body: JSON.stringify({
        entiteit: row.entiteit,
        year: row.year,
        budget_scenario: row.budget_scenario,
        office: row.office,
        user_id: await getCurrentUser(),
      }),
    });
    if (response.ok) {
      // const responseData = await response.json();  
      // return responseData;
      await enableUpdateImports();
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    handleStatus({"text": "Error!", "progress": 1, "status": 0});
  }
}
export async function getXeroCompany(currentUser){
  const response = await fetch('/xero/getCompany', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({current_user: currentUser}),
  });
  if (response.ok) {

    const responseData = await response.json();
    
    if(responseData){
      return responseData;
    }
  }
}
export async function getAdministrations(currentUser){
  const response = await fetch('/xero/getAdministration?currentUser='+currentUser);
  if (response.ok) {
    const responseData = await response.json();

    if(responseData){
      var administrations = [];
      for(var i = 0; i < responseData.length; i++){
        var adminObj = false;
        if(responseData[i].code && responseData[i].description){
          adminObj = {"Description": responseData[i].description, "Code": responseData[i].code, "type":'administration'};
        }
        else if(responseData[i].value && responseData[i].name){
          adminObj = {"Description": responseData[i].name, "Code": responseData[i].value, "type":'administration'};
        }

        if(adminObj){
          administrations.push(adminObj);
        }
      };

      return administrations;
    }
  }
}

async function findByDivision(office){
  var response = await fetch('/import_xero/getListArray?division='+office);
  if(response.ok){
    var responseData = response.json();
    return responseData;
  }
}

export async function getXeroConfig(currentUser){
  try{
    const response = await fetch('https://api2.factview.nl/user/getXero?currentUser='+currentUser, {
      method: 'GET',
      headers: {
        'authorization': 'Bearer '+ getCookie("factview_access"),
        'Content-Type': 'application/json',
        'Accept': 'application/json' 
      }
    });

    if (response.ok) {
      const responseData = await response.json();

      if(responseData){
        
        return responseData;
      }
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}
export async function getImportXero(offices, cases){
  try{
    const response = await fetch('/import_xero/getImportXeroByDivisions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        division: offices,
        userCases: cases,
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}
export async function createImport(importConfig){
  try{
    updateUserLastAction();
    const response = await fetch('/xero/createImport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(importConfig),
    })
    if (response.ok) {
      
      const responseData = await response.json();
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}



//Submits import xero updates/changes
export async function updateImportXero(id, openingBalance, ignoreYearEnd){
  try{
    const response = await fetch('/import_xero/updateImportXero', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: id,
        openingBalance: openingBalance,
        ignoreYearEnd: ignoreYearEnd,
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

// Delete import exact by id
export async function deleteImportXero(id){
  try { 
    // var importData = data.filter(item => item.id == id)[0];
    const importResponse = await fetch('/import_xero/getById?id='+id);
    if(importResponse.ok){
      const importData = await importResponse.json();

      await clearExistingScheduledImports({"import_type": "xero", "entiteit": importData["entiteit"], "year": importData["year"],"office": importData["office"], "budget_scenario": importData["budget_scenario"]});
      
      const response = await fetch('/import_xero/deleteImportXero?id='+id);
      if (response.ok) {
      const responseData = await response.json();
      
      if(responseData){
      }
    }
    
    }
  } catch (error) {
    console.error('Error deleting data:', error);
  }
}
// Handles fetching status updates from the server
async function handleStatus(updateStatus, init){
  try{
    if(init){
      await fetch('/xero/fetchUpdates');
      setTimeout(function(){
        handleStatus(updateStatus, false, 0);
      },500);
    }else{
      const response = await fetch('/xero/fetchUpdates');
      if (response.ok) {
        const responseData = await response.json();
        
        if(responseData){
          updateStatus(responseData);

          if(responseData.length > 0 && responseData[responseData.length-1]["status"] == 1){
            setTimeout(function(){
              handleStatus(updateStatus, false);
            }, 750);
          }
        } 
      }
    }
  } catch(error) {
    setTimeout(function(){
      handleStatus(updateStatus, false);
    },500);
  }
}



